var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Children, createElement } from 'react';
var wrapChildren = function (child, props) { return (__assign(__assign({}, child), { props: __assign(__assign({}, child.props), { children: child.props.children
            ? getWrapedChildren(child.props.children, props)
            : child.props.children }) })); };
export var getWrapedChildren = function (children, props) {
    return Children.map(children, function (child) {
        if (!child || typeof child !== 'object' || !('type' in child)) {
            return child;
        }
        var result;
        props.wrappers.forEach(function (_a) {
            var targetTagName = _a.targetTagName, wrapperTagName = _a.wrapperTagName, wrapperClassName = _a.wrapperClassName;
            if (child.type === targetTagName) {
                result = createElement(wrapperTagName, { className: wrapperClassName }, wrapChildren(child, props));
            }
        });
        return result !== null && result !== void 0 ? result : wrapChildren(child, props);
    });
};
//# sourceMappingURL=getWrapedChildren.js.map